// types
import { ColumnHeaderRowType } from "components/atoms/ExpandedRowTable/ExpandedRowTable";

export const DATE_TIME: ColumnHeaderRowType = {
	title: "Date & Time",
	dataIndex: "declared_on",
	align: "left",
	width: "10%"
};
export const YEAR_MONTH: ColumnHeaderRowType = {
	title: "Year Month",
	dataIndex: "yearmonth",
	align: "left",
	width: "10%"
};
export const TENANT: ColumnHeaderRowType = {
	title: "Tenant",
	dataIndex: "tenant_name",
	align: "left",
	width: "14%"
};
export const OUTLET: ColumnHeaderRowType = {
	title: "Outlet",
	dataIndex: "outlet_name",
	align: "left",
	width: "14%"
};
export const OUTLET_CODE: ColumnHeaderRowType = {
	title: "Outlet Code",
	dataIndex: "outlet_code",
	align: "left",
	width: "14%"
};
export const NETT_AMOUNT: ColumnHeaderRowType = {
	title: "Nett Amount",
	dataIndex: "net_amount",
	align: "left",
	width: "8%"
};
export const DECLARED_AMOUNT: ColumnHeaderRowType = {
	title: "Declared Amount",
	dataIndex: "tenant_amount",
	align: "left",
	width: "8%"
};
export const REIMB_AMOUNT: ColumnHeaderRowType = {
	title: "Reimbursement Amount",
	dataIndex: "reimb_amount",
	align: "left",
	width: "10%"
};
export const STATUS: ColumnHeaderRowType = {
	title: "Status",
	dataIndex: "reimb_status",
	align: "left",
	width: "14%"
};
export const REVIEW: ColumnHeaderRowType = {
	title: "Review",
	dataIndex: "review",
	align: "left",
	width: "6%"
};
